import { Box, Button } from '@mui/material'
import { useEffect, useState } from 'react'

import { connect, useSelector } from 'react-redux'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { Item } from '../../common/snippets'
import { SplitButton } from '../../common/SplitButton'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../common/svg/refresh'
import * as id from './reportId'
import * as lb from './reportLables'
import { ReportHeading } from './common/ReportHeading'
import { appendToUrl, focusElemnt, getInt, isEmpty, navigation3 } from '../../common/helper'
import moment from 'moment'
import * as url from './oldReportsUrls'
import { getBranchReceiveFilter } from '../../../store/reports/reports_action'
import { PaymentTypesOptions, reportViewOpt, urls } from '../../common/constants'
import BranchReceive from './BranchTransfer/BranchReceive'
import Alert from '../../common/alert'
import { updateLoader, updateModal } from '../../../store/common/common_action'
import { GetRequest } from '../../common/api'
import ManageColumns from '../../common/ManageColumnsUI'
import * as mdt from '../../common/modaltypes'
import { BranchReceiveHeader, BranchReceiveHeaderForBoth, BranchReceiveHeaderFormatedLR, BranchReceiveHeaderForPortrait, BranchReceiveHeaderForRemoveGST } from './BranchTransfer/excelTable/BranchReceiveConstant'
import { RAJESH_TRANSPORT, STA_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { divideInNIntegers } from '../../common/mathHelper'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import { downloadPDF } from './analysisReport/pdfAutotable'
const BranchReceiveReport = (props) => {
  const {
    data: { common, reports },
    getBranchReceiveFilter,
    updateLoader,
    updateModal
  } = props
  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel } = { ...roleRightsData }
  let { AllowViewAllBranchOfCityReport } = { ...roleRightsData }
  const [searchParams] = useSearchParams()
  const { showModal, modalType } = common
  const disableBtnFromSearchParams = searchParams.get("disableBtn")

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = searchParams.get('C') || 0
    loginData.intUserID = searchParams.get('U') || 0
    loginData.intBranchID = searchParams.get('B') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = searchParams.get('AllowViewAllBranchOfCityReport') || 0
    isFromUrl = true
  }
  let { DefaultCurrencyID } = companySettings
  if (!DefaultCurrencyID) {
    DefaultCurrencyID = +searchParams.get('DC') || 1
  }
  const { intCompanyID, IsAdmin, intBranchID, strCompanyName, IsBranchAdmin, strBranchName, IsMTPLAdmin } = loginData
  const reportName = DefaultCurrencyID === 2 ? 'SC Trans Receive Report' : 'Branch Transfer Received Report'
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports || 0
  const BranchTransferReceivePortrait = companySettings?.[0]?.BranchTransferReceivePortrait || 0
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD
  const [selCompany, setSelCompany] = useState(false)

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selFromBranch, setSelFromBranch] = useState('')
  const [selToBranch, setSelToBranch] = useState('')
  const [selVehicle, setSelVehicle] = useState('')

  const [receiveByBranchList, setReceiveByBranchList] = useState([])
  const [receiveToBranchList, setReceiveToBranchList] = useState([])
  const [vehicleList, setVehicleList] = useState([])
  const [resetFlag, setResetFlag] = useState(false)
  const [selPaymentType, setSelPaymentType] = useState(PaymentTypesOptions[0])
  const [selReportView, setselReportView] = useState(reportViewOpt[1])
  const [tableData, setTableData] = useState([])
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  const [filterData, setFilterData] = useState({
    CompanyName: '',
    FromDate: '',
    ToDate: '',
    fromBranchName: '',
    toBranchName: '',
    VehicleNo: '',
    payment: '',
    Report: '',
  });
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [showReport, setShowReport] = useState(false)
  const [branchReceive, setBranchReceive] = useState({})
  const [isPdfLoading, setIsPdfLoading] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const sourceColumns = [
    {
      id: 1001,
      header: 'Source\nCity',
      exportHead: 'Source\nCity',
      field: 'FromCity',
      isSelected: true,
      isDefault: false,
      isMandatory: false,
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 100,
      },
      isSortIcon: true,
      headerSx: { minWidth: '110px', textAlign: 'left' },
      xlCol: { dataType: 'string', dataFormatter: null, fontSize: 5 },
    },
    {
      id: 1002,
      header: 'Source\nBranch',
      exportHead: 'Source\nBranch',
      field: 'SendingBranch',
      isSelected: true,
      isDefault: false,
      isMandatory: false,
      pdfColSx: {
        halign: 'left',
        textColor: [0, 0, 0],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        font: 'Roboto',
        fontStyle: 'normal',
        valign: 'top',
        minCellWidth: 120,
      },
      isSortIcon: true,
      headerSx: { minWidth: '130px', textAlign: 'left' },
      xlCol: { dataType: 'string', dataFormatter: null, fontSize: 5 },
    },
  ]
  const addSourceColumns = (columns = []) => {
    const sanitizedColumns = columns.filter((col) => !['FromCity', 'SendingBranch'].includes(col.field))
    if (![STA_COMPANY_ID].includes(intCompanyID)) {
      return sanitizedColumns
    }
    const senderIndex = sanitizedColumns.findIndex((col) => col.field === 'Sender')
    const insertIndex = senderIndex === -1 ? sanitizedColumns.length : senderIndex
    return [
      ...sanitizedColumns.slice(0, insertIndex),
      ...sourceColumns,
      ...sanitizedColumns.slice(insertIndex),
    ]
  }
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Transfer Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Transfer  Date', textAlign: 'left' },
    { field: 'selFromBranch', header: 'Transfer By Branch', textAlign: 'left' },
    { field: 'selToBranch', header: 'Transfer To Branch', textAlign: 'left' },
    { field: 'selVehicle', header: 'Vehicle Number', textAlign: 'left' },
    { field: 'selPaymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'selReportView', header: 'Report View`', textAlign: 'left' },
  ]
  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    selFromBranch: selFromBranch?.name || '',
    selToBranch: selToBranch?.name || '',
    selVehicle: selVehicle?.name || `Auto-Dispatch.`,
    selPaymentType: selPaymentType?.Name || '',
    selReportView: selReportView?.name || '',
    dataType: 'entry',
  }
  useEffect(() => {
    if (!isEmpty(branchReceive)) {
      let TransferFromBranch = branchReceive.BranchRecieveFromBranch.map((el) => ({ id: el.FromBranchID, name: el.FromBranch }))
      setReceiveByBranchList(TransferFromBranch)

      let defaultBranch = TransferFromBranch.filter((obj) => obj?.id === intBranchID)
      if (disableBtn && AllowViewAllBranchOfCityReport == 0) {
        defaultBranch = TransferFromBranch.filter((obj) => obj?.id !== intBranchID)
      }

      const TransferToBranch = branchReceive.BranchRecieveToBranch.map((el) => ({ id: el.ToBranchID, name: el.ToBranch, FromBranchID: el.FromBranchID }))
      setReceiveToBranchList(TransferToBranch)
      const TransferVehicle = branchReceive.BranchRecieveVehicle.map((el) => ({ id: el.VehicleID, name: el.VehicleNo, FromBranchID: el.FromBranchID, ToBranchID: el.ToBranchID }))
      setVehicleList(TransferVehicle)
      if (defaultBranch.length) {
        setSelFromBranch(defaultBranch[0])
        if (TransferToBranch.length) {
          let defaultToBranch = TransferToBranch.filter((val) => val?.FromBranchID === defaultBranch[0]?.id)
          if (disableBtn && AllowViewAllBranchOfCityReport == 0) {
            defaultToBranch = TransferFromBranch.filter((obj) => obj?.FromBranchID !== intBranchID)
          }
          if (defaultToBranch.length) {
            setSelToBranch(defaultToBranch[0])
            if (TransferVehicle.length) {
              let defaultVehicle = TransferVehicle.filter((val) => val?.FromBranchID === defaultBranch[0]?.id && val?.ToBranchID === defaultToBranch[0]?.id)
              if (defaultVehicle.length) {
                setSelVehicle(defaultVehicle[0])
              }
            }
          }
        }
      } else {
        setSelFromBranch(TransferFromBranch[0])
        if (TransferToBranch.length) {
          let defaultToBranch = TransferToBranch.filter((val) => val?.FromBranchID === TransferFromBranch[0]?.id)
          if (defaultToBranch.length) {
            setSelToBranch(defaultToBranch[0])
            if (TransferVehicle.length) {
              let defaultVehicle = TransferVehicle.filter((val) => val?.FromBranchID === TransferFromBranch[0]?.id && val?.ToBranchID === defaultToBranch[0]?.id)
              if (defaultVehicle.length) {
                setSelVehicle(defaultVehicle[0])
              }
            }
          }
        }
      }
      if (disableBtn && AllowViewAllBranchOfCityReport == 0) {
        setSelToBranch({ name: strBranchName, id: intBranchID })
      }

    } else {
      setReceiveByBranchList([])
      setReceiveToBranchList([])
      setVehicleList([])
      setSelFromBranch('')
      setSelToBranch('')
      setSelVehicle('')
      setResetFlag(!resetFlag)
    }
  }, [branchReceive])
  useEffect(() => {
    const getLocalData = (key) => {
      return new Promise((resolve) => {
        const localData = localStorage.getItem(key)
        resolve(localData ? JSON.parse(localData) : null)
      })
    }

    const updateColumnDetails = async () => {
      const BranchReceiveHeaderCol =
        UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1
          ? BranchReceiveHeader
          : UseFormattedLRinReports === 2
            ? BranchReceiveHeaderFormatedLR
            : BranchReceiveHeaderForBoth

      try {
        if (BranchTransferReceivePortrait === 1) {
          let usedCols = []
          const BranchReceiveHeaderForPortraitCol = await getLocalData('BranchReceiveHeaderForPortrait')
          if (UseFormattedLRinReports !== 3) {
            usedCols = addSourceColumns((BranchReceiveHeaderForPortraitCol || BranchReceiveHeaderForPortrait).filter(
              (item) => item.field !== 'FormattedLRNO'
            ))
          } else {
            usedCols = addSourceColumns(BranchReceiveHeaderForPortraitCol || BranchReceiveHeaderForPortrait)
          }
          setManageColumn(usedCols)
        } else {
          const localBrnhTransfCol = await getLocalData('BranchTransferReceive1')
          const BranchReceiveRemoveGSTCol = await getLocalData('BranchReceiveHeaderForRemoveGST1')

          let usedCol = []
          if (DefaultCurrencyID === 2) {
            usedCol = BranchReceiveRemoveGSTCol || BranchReceiveHeaderForRemoveGST
          } else {
            usedCol = localBrnhTransfCol || BranchReceiveHeaderCol
          }
          usedCol = addSourceColumns(usedCol)

          // ✅ Rename valuation column based on country
          usedCol = usedCol.map((col) => {
            if (col.field === 'Valuation') {
              return {
                ...col,
                header: DefaultCurrencyID === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
                exportHead: DefaultCurrencyID === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.',
              }
            }
            return col
          })
          if (RAJESH_TRANSPORT === intCompanyID) {
            usedCol = usedCol.filter(
              (col) =>
                !['Sender', 'SenderGSTN', 'RecName', 'ReceiverGSTN', 'NetAmount', 'GrossAmount'].includes(col.field)
            )
            if (!usedCol.some((c) => c.field === 'Remarks')) {
              usedCol.push({
                id: 20,
                header: 'Remarks',
                exportHead: 'Remarks',
                field: 'Remarks',
                isSelected: true,
                isDefault: true,
                isMandatory: true,
                pdfColSx: {
                  minCellHeight: 36,
                  textColor: [0, 0, 0],
                  cellPadding: 6,
                  font: 'Roboto',
                  valign: 'middle',
                  halign: 'left',
                  fontSize: 12,
                  minCellWidth: 100,
                },
                xlCol: { dataType: 'string', dataFormatter: null, fontSize: 5 },
              })
            }
          }
          setManageColumn(usedCol)
        }
      } catch (error) {
        setManageColumn(
          BranchTransferReceivePortrait === 1
            ? addSourceColumns(BranchReceiveHeaderForPortrait)
            : DefaultCurrencyID === 2
              ? addSourceColumns(BranchReceiveHeaderForRemoveGST)
              : addSourceColumns(BranchReceiveHeaderCol)
        )
        console.error(error)
      }
    }

    updateColumnDetails()
  }, [
    BranchTransferReceivePortrait,
    UseFormattedLRinReports,
    DefaultCurrencyID,
    RAJESH_TRANSPORT,
    intCompanyID,
  ])
  useEffect(() => {
    if (intCompanyID && roleRightsData) {
      const isDisableBtnByRole = !(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin)
      setDisableBtn(isDisableBtnByRole || disableBtnFromSearchParams)
      setDisableExcel(!AllowExportExcel)
    }
  }, [roleRightsData, intCompanyID, disableBtnFromSearchParams, AllowViewAllBranchReport, AllowBranchInchargeRights, IsBranchAdmin, IsMTPLAdmin, IsAdmin, AllowExportExcel])

  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])
  const handleClick2 = () => {
    if (selFromBranch === '' || selFromBranch === ' ') {
      setShowAlert({ show: true, message: "Please select From Branch" })
    } else if (selToBranch === '' || selToBranch === ' ') {
      setShowAlert({ show: true, message: "Please select To Branch" })
    } else if (selVehicle === '' || selVehicle === ' ') {
      setShowAlert({ show: true, message: "Please select Vehicle No" })
    } else {
      let baseUrl = url.branchReceive
      const urlData = url.branchReceiveReceive
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDt = fromDate.format('DD-MMM-YYYY')
      urlData.ToDt = toDate.format('DD-MMM-YYYY')
      urlData.FromBranchId = selFromBranch?.id
      urlData.ToBranchId = selToBranch?.id
      urlData.VehicleNo = selVehicle?.name
      urlData.intAllowExportExcel = 1
      baseUrl = appendToUrl(baseUrl, urlData)
      window.open(baseUrl, '_blank')
    }
  }
  const callFilterAPi = () => {
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
      setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
    } else {
      const obj = {
        DateFrom: fromDate.format('YYYY-MM-DD'),
        DateTo: toDate.format('YYYY-MM-DD'),
        intBranchID: 0,
        intCompanyID,
      }
      getBranchReceiveFilter(obj).then((res) => {
        if (res?.status == 'Success') {
          if (res.Data[0].BranchRecieveFromBranch.length) {
            setBranchReceive(res.Data[0])
          } else {
            setBranchReceive({})
            setShowAlert({ show: true, message: 'No Data Found On Selected Date Range', nextId: '' })
          }
        } else {
          setShowAlert({ show: true, message: res.ErrMessage, nextId: '' })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }
  const makeSubHeadingRows = (headers, val) => {
    const { pickedHeaders, lengths } = getPickedHeaders(headers, 3)
    return {
      dataType: 'subHeader',
      colSpan: Object.fromEntries(
        pickedHeaders.map((key, i) => [key, lengths[i]])
      ),
      totalSubKey:3,
      align: {
        [pickedHeaders[0]]: 'left',
        [pickedHeaders[1]]: 'center',
        [pickedHeaders[2]]: 'right'
      },
      [pickedHeaders[0]]: `Payment Type: ${val}`,
      [pickedHeaders[1]]: `Transfer From Branch: ${selFromBranch?.name}`,
      [pickedHeaders[2]]: `Transfer To Branch: ${selToBranch?.name}`,
    }
  }
  const getPickedHeaders = (headers, parts = 3) => {
    const lengths = divideInNIntegers(headers.length, parts)
    let index = 0
    const pickedHeaders = []

    lengths.forEach(span => {
      pickedHeaders.push(headers[index]?.field)
      index += span
    })
    return { pickedHeaders, lengths }
  }
  const formatData = (data) => {
    let headers = manageColumn.filter((obj) => obj.isSelected)
    const firstField = headers[0]?.field;
    const groupedData = data.reduce((result, item) => {
      const key = `${item.PaymentType}`
      if (!result[key]) {
        result[key] = []
      } result[key].push(item)
      return result
    }, {})
    let newData = []
    let grandTotalRow = { Units: 0, Freight: 0, CartageAmount: 0, HamaliCharge: 0, OtherCharges: 0, Valuation: 0, BookingGST: 0, NetAmount: 0 }
    Object.keys(groupedData).map((val, index) => {
      let detailsData = []
      let totalRow = { Units: 0, Freight: 0, CartageAmount: 0, HamaliCharge: 0, OtherCharges: 0, Valuation: 0, BookingGST: 0, NetAmount: 0 }
      let headingRow = { dataType: 'header', sno: "S/N", LRNO: "LR No\nMan.LR No", ChallanNo: 'Challan\nNo', ReceiptDate: "Rcvr.Date\nRcvr.Time", FromCity: 'Source\nCity', SendingBranch: 'Source\nBranch', Sender: "Sndr. Name\nSndr. No.", SenderGSTN: 'Sndr. GSTIN\nSndr. EmailID.', RecName: "Rcvr. Name\nRcvr. No", ReceiverGSTN: 'Rcvr. GSTIN\nRcvr. EmailID', ItemDetails: "Item\nDetails", Units: 'Item\nUnits', Freight: 'Frt\nChrg', CartageAmount: 'Cart.\nChrg.', HamaliCharge: 'Ham.\nChrg.', OtherCharges: 'Oth.\nChrg.', Valuation: DefaultCurrencyID === 2 ? 'Insu.\nChrg.' : 'Val.\nChrg.', BookingGST: 'Bkg.\nGST', NetAmount: 'Net.\nAmt.' };
      if (intCompanyID === RAJESH_TRANSPORT) {
        headingRow.Remarks = 'Remarks';
      }
      if (UseFormattedLRinReports === 2) {
        headingRow.LRNO = "Formatted LRNO\nMan.LR No"; // Change LRNO heading
      } else if (UseFormattedLRinReports === 3) {
        headingRow.FormattedLRNO = "Formatted\nLRNO"; // Add new heading after LRNO
      }
      let subHeading = makeSubHeadingRows(headers, val)
      groupedData[val]?.map((val, index) => {
        detailsData.push({ ...val, dataType: 'entry', ReceiptDate: moment(new Date(val.ReceiptDate)).format("DD-MMM-YY"), ReceiptTime: moment(new Date(val.ReceiptDate)).format("HH:mm") })
        totalRow = {
          Units: totalRow.Units + Number(val.Units),
          Freight: totalRow.Freight + Number(val.Freight),
          CartageAmount: totalRow.CartageAmount + Number(val.CartageAmount),
          HamaliCharge: totalRow.HamaliCharge + Number(val.HamaliCharge),
          OtherCharges: totalRow.OtherCharges + Number(val.OtherCharges),
          Valuation: totalRow.Valuation + Number(val.Valuation),
          BookingGST: totalRow.BookingGST + Number(val.BookingGST),
          NetAmount: totalRow.NetAmount + Number(val.NetAmount),
        }
      });
      grandTotalRow = {
        Units: grandTotalRow.Units + totalRow.Units,
        Freight: grandTotalRow.Freight + totalRow.Freight,
        CartageAmount: grandTotalRow.CartageAmount + totalRow.CartageAmount,
        HamaliCharge: grandTotalRow.HamaliCharge + totalRow.HamaliCharge,
        OtherCharges: grandTotalRow.OtherCharges + totalRow.OtherCharges,
        Valuation: grandTotalRow.Valuation + totalRow.Valuation,
        BookingGST: grandTotalRow.BookingGST + totalRow.BookingGST,
        NetAmount: grandTotalRow.NetAmount + totalRow.NetAmount,
      }
      detailsData.sort((a, b) => moment(`${a.ReceiptDate} ${a.ReceiptTime}`).valueOf() - moment(`${b.ReceiptDate} ${b.ReceiptTime}`).valueOf());
      detailsData = detailsData.map((val, index) => ({ ...val, sno: index + 1 }))
      if (index !== 0) newData.push(headingRow);
      newData.push(
        subHeading,
        ...detailsData,
        {
          ...totalRow,
          dataType: 'total',
          [firstField]: `Total: Transfer From Branch: ${filterData.fromBranchName} : Payment Type: ${val}`,
          colSpan: {
            [firstField]: headers?.lenght > 12 ? 3 : 6
          },
          align: {
            [firstField]: 'right'
          }
        }
      );
    })

    newData.push({
      ...grandTotalRow,
      dataType: 'total',
      [firstField]: `Total: Transfer From Branch: ${filterData.fromBranchName} : Payment Type: ${filterData.payment}`,
      colSpan: {
        [firstField]: headers?.lenght > 12 ? 3 : 6
      },
      align: {
        [firstField]: 'right'
      }
    });
    return newData
  }
  const generateReport = (isPdf = false) => {
    setShowReport(false)
    setIsPdfLoading(false)
    if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
      setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
    } else if (selFromBranch === '' || selFromBranch === ' ') {
      setShowAlert({ show: true, message: "Please select From Branch" })
    } else if (selToBranch === '' || selToBranch === ' ') {
      setShowAlert({ show: true, message: "Please select To Branch" })
    } else if (selVehicle === '' || selVehicle === ' ') {
      setShowAlert({ show: true, message: "Please select Vehicle No" })
    } else {
      setFilterData({
        ...filterData,
        CompanyName: strCompanyName,
        FromDate: moment(new Date(fromDate)).format("DD-MMM-YYYY"),
        ToDate: moment(new Date(toDate)).format("DD-MMM-YYYY"),
        fromBranchName: selFromBranch?.name,
        toBranchName: selToBranch?.name,
        VehicleNo: selVehicle?.name,
        payment: selPaymentType?.Name,
        Report: selReportView?.name,
      })
      const body = {
        FromBranchID: selFromBranch?.id,
        ToBranchID: selToBranch?.id,
        CompanyID: intCompanyID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        PaymentTypeIDs: selPaymentType?.id,
        VehicleNo: selVehicle?.name,
      }
      updateLoader(true)
      GetRequest(urls.getBranchReceiveData, body).then((res) => {
        if (res.status == 'Success') {
          //  setShowReport(true)
          updateLoader(false)
          const data = res?.Data?.Table?.map((val, index) => ({ ...val, sno: index + 1, dataType: 'entry', PaymentType: UseToPayAsCOD === 1 && val.PaymentTypeID === 2 ? 'COD' : val.PaymentTypeID === 7 ? 'COD(MANUAL)' : val.PaymentTypeID === 9 ? 'COD(DDDV)' : val.PaymentType }))
          // setTableData(data)
          const data1 = formatData(data)
          let mainHeader = manageColumn.filter((obj) => obj.isSelected)?.map((val) => ({
            ...val,
            field: val.field,
            align: val.headerSx.textAlign,
            export: val.exportHead,
            weight: 80,
            width: getInt(val.headerSx?.minWidth),
          }))
          let manageColId = BranchTransferReceivePortrait === 1 ? 'BranchReceiveHeaderForPortraitAk' : DefaultCurrencyID === 2 ? 'BranchReceiveHeaderForRemoveGST1Ak' : 'BranchTransferReceive1AK'
          const reportPayload = {
            reportName,
            criteriaHeaders: criteriaHeaders,
            criteriaData: [criteriaData],
            tableData: data1,
            mainHeader: mainHeader,
            isShowManageColumn: true,
            manageColumnID: manageColId,
            colSpanMarker: "RecName",
            totalSubKey:3,
          }
          if (isPdf === true) {
            downloadPDF({
              reportName,
              criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: data1,
              visibleColumns:mainHeader,
              loginData,
              hideHeader:false
            })
            return
          }
          const rid = Date.now().toString()

          if (!window.generatedReports) {
            window.generatedReports = {}
          }

          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        } else {
          updateLoader(false)
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        updateLoader(false)
        console.log('Error:', err)
      })
    }
  }
  //handle Close Alert
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  const handleFromBranch = (val) => {
    setSelFromBranch(val)
    let toBranchList = receiveToBranchList?.filter((obj) => obj?.FromBranchID === val?.id);
    if (toBranchList.length) {
      if (disableBtn && AllowViewAllBranchOfCityReport == 0) {
      } else {
        setSelToBranch(toBranchList[0])
      }
      let vehicleListFilter = vehicleList?.filter((obj) => obj.FromBranchID === val?.id && obj.ToBranchID === toBranchList[0]?.id)
      if (vehicleListFilter.length) {
        setSelVehicle(vehicleListFilter[0])
      } else {
        setSelVehicle(' ')
      }
    } else {
      setSelToBranch(' ')
      setSelVehicle(' ')
    }
  }
  const handleToBranch = (val) => {
    setSelToBranch(val)
    let vehicleListFilter = vehicleList?.filter((obj) => obj.FromBranchID === val?.FromBranchID && obj.ToBranchID === val?.id)
    if (vehicleListFilter.length) {
      setSelVehicle(vehicleListFilter[0])
    } else {
      setSelVehicle(' ')
    }
  }

  const onSaveColumns = (item) => {
    setManageColumn(item)
    localStorage.setItem(BranchTransferReceivePortrait === 1 ? 'BranchReceiveHeaderForPortrait' : DefaultCurrencyID === 2 ? 'BranchReceiveHeaderForRemoveGST1' : 'BranchTransferReceive1', JSON.stringify(item))
  }
  let selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})
  const mainHeader = ['sno', 'LRNO', 'ChallanNo', 'ReceiptDate', 'FromCity', 'SendingBranch', 'Sender', 'SenderGSTN', 'RecName', 'ReceiverGSTN', 'ItemDetails']
  if (UseFormattedLRinReports === 3) {
    const lrIndex = mainHeader.indexOf('LRNO');
    if (lrIndex !== -1) {
      mainHeader.splice(lrIndex + 1, 0, 'FormattedLRNO');
    }
  }
  const matchFields = Object.fromEntries(
    Object.entries(selectedFields).filter(([key]) => mainHeader.includes(key))
  );
  return (
    <Item sx={{ padding: '0' }} className="reports">
      {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
      {isFromUrl ? <></> : <ReportHeading reportName={reportName.slice(0, -7)} />}
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start',gap:isFromUrl?'15px':'10px' }}>
        {isFromUrl ? <></> : 
        <><Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompnay}
            label={lb.select_company}
            defaultvalue={strCompanyName}
            disabled={true}
            onSelect={(val) => setSelCompany(val)}
            width="300px"
          />{' '}
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
            GO
          </Button>
        </Item>
        </>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Receive Date`}
            name={'from_date'}
            value={fromDate}
            id={id.fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Receive  Date'}
            name={'to_date'}
            value={toDate}
            id={id.toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt(id.goButtonDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            variant="contained"
            id={id.goButtonDate}
            onClick={callFilterAPi}
            onKeyDown={(e) => {
              navigation3(e, id.selBranch, id.toDate, () => {
                callFilterAPi()
              })
            }}
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={'Transfer From Branch'}
            id={id.selBranch}
            defaultvalue={selFromBranch?.name || selFromBranch}
            value={selFromBranch?.name || selFromBranch}
            data={disableBtn && AllowViewAllBranchOfCityReport == 1 ? receiveByBranchList?.filter((val) => val.id == intBranchID) : receiveByBranchList || []}
            dataKey={`name`}
            resetFlag={resetFlag}
            idKey={`id`}
            onSelect={(val) => handleFromBranch(val)}
            width="100%"
            nextId={id.destinationBranch}
            prevId={id.goButtonDate}
          />
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={'Received By Branch'}
            id={id.destinationBranch}
            data={receiveToBranchList?.filter((obj) => obj?.FromBranchID === selFromBranch?.id) || []}
            defaultvalue={selToBranch?.name || selToBranch}
            value={selToBranch?.name || selToBranch}
            disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(val) => handleToBranch(val)}
            resetFlag={resetFlag}
            width="100%"
            nextId={id.vehicle}
            prevId={id.selBranch}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label={lb.vehicle}
            id={id.vehicle}
            data={vehicleList?.filter((obj) => obj.FromBranchID === selFromBranch?.id && obj.ToBranchID === selToBranch?.id)}
            defaultvalue={selVehicle?.name || selVehicle}
            value={selVehicle?.name || selVehicle}
            resetFlag={resetFlag}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(vehicle) => setSelVehicle(vehicle)}
            width="100%"
            nextId={id.paymentType}
            prevId={id.destinationBranch}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label={lb.paymentType}
            id={id.paymentType}
            data={PaymentTypesOptions}
            searchPlaceholder={`Search By Payment`}
            defaultvalue={selPaymentType?.Name}
            HasAllSelect={true}
            disabled={true}
            dataKey={`Name`}
            idKey={`id`}
            onSelect={setSelPaymentType}
            nextId={id.reportView}
            prevId={id.vehicle}
            width="100%"
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            label={lb.reportView}
            id={id.reportView}
            data={reportViewOpt}
            searchPlaceholder={`Search By Report`}
            defaultvalue={selReportView?.name}
            dataKey={`name`}
            disabled={true}
            idKey={`id`}
            onSelect={setselReportView}
            nextId={id.reportmainButton}
            prevId={id.paymentType}
            width="100%"
          />
        </Item>
        {isFromUrl ?
          <Button variant="contained" sx={{width:'100%',height:'40px'}} className="btn btn-primary" onClick={()=>generateReport(true)} id1={id.reportmainButton}>
            DOWNLOAD PDF
          </Button> : 
        <>
        <Item sx={sx.itemsx} onKeyDown={(e) => {
          navigation3(e, showReport ? isPdfLoading ? "backBtn" : disableExcel ? "exportPdf" : "exportExcelBtn" : id.fromDate, id.reportView, () => {
            generateReport()
          })
        }}>
          <SplitButton
            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
            hideToggle={false}
            id1={id.reportmainButton}
            onClick1={generateReport}
            onClick2={handleClick2}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, cursor: 'pointer' }} onClick={() => {
          setFromDate(moment(new Date()))
          setToDate(moment(new Date()))
          setSelVehicle('')
          setSelToBranch('')
          setSelFromBranch('')
          setReceiveByBranchList([])
          setReceiveToBranchList([])
          setVehicleList([])
          setResetFlag(!resetFlag)
        }} >
          <RefreshSvg />
        </Item>
        </>}
      </Box>
      {showModal && mdt.BrnhTransferRecCol === modalType ? <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} /> : null}
      {showReport && <BranchReceive loginCountryId={DefaultCurrencyID} updateModal={updateModal} disableExcel={disableExcel} loginData={loginData} filterData={filterData} tableData={tableData} updateLoader={updateLoader} columnSummaryDefs={manageColumn.filter((obj) => obj.isSelected)} selectedFields={selectedFields} matchFields={matchFields} isPdfLoading={isPdfLoading} setIsPdfLoading={setIsPdfLoading} UseFormattedLRinReports={UseFormattedLRinReports} />}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}

    </Item>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchReceiveFilter, updateLoader, updateModal }
export default connect(mapStateToProps, mapDispatchToProps)(BranchReceiveReport)
